import { ResourceName } from '../ResourceName'

const mapping: Record<string, string> = {
  [ResourceName.ACCESSES]: 'filterAccessId',
  [ResourceName.ENGINES]: 'filterVerifierDeviceId',
  [ResourceName.DEPOSITORS]: 'filterVerifierDeviceId',
  [ResourceName.ENTRANCES]: 'filterEntranceId',
  [ResourceName.EVENTS]: 'filterEventId',
  [ResourceName.PALMS]: 'filterVerifierDeviceId',
  [ResourceName.VARIANTS]: 'filterVariantId',
  [ResourceName.ROLES]: 'filterRoleId',
  [ResourceName.USERS]: 'filterUserId',
  [ResourceName.STATS_DYNAMIC_STATISTICS]: 'filterDynamicStatisticId',
  [ResourceName.TERMINALS]: 'filterVerifierDeviceId',
  [ResourceName.DOORS]: 'filterVerifierDeviceId',
  [ResourceName.NOTIFICATION_TAGS]: 'filterNotificationTagId',
  [ResourceName.ENGINE_MEDIA_FILES]: 'filterFileId',
  [ResourceName.ENGINE_MEDIA_PACKS]: 'filterPackId',
}

const filterMapper = (key: ResourceName) => mapping[key]

export default filterMapper
